<!-- src/components/ezer/EzerAssistantBubble.vue -->
<template>
  <div class="ezer-bubble ezer-bubble--assistant">
    <div class="ezer-bubble__avatar">
      <svg viewBox="0 0 20 20" width="18" height="18" fill="var(--ezer-primary)">
        <path d="M10 1a6 6 0 0 1 6 6v1a6 6 0 0 1-3 5.2V16a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 7 16v-2.8A6 6 0 0 1 4 8V7a6 6 0 0 1 6-6z"/>
      </svg>
    </div>
    <div class="ezer-bubble__body">
      <div class="ezer-bubble__content ezer-markdown" v-html="renderedHtml"></div>
      <span v-if="isStreaming" class="ezer-cursor">|</span>

      <!-- Tool call indicators -->
      <div v-if="toolCalls?.length" class="ezer-tool-list">
        <EzerToolStatus v-for="tc in toolCalls" :key="tc.id" :tool="tc" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import EzerToolStatus from './EzerToolStatus.vue'

export default {
  name: 'EzerAssistantBubble',
  components: { EzerToolStatus },
  props: {
    text: { type: String, default: '' },
    isStreaming: Boolean,
    toolCalls: Array,
  },
  setup(props) {
    const renderedHtml = computed(() => {
      if (!props.text) return ''
      const raw = marked.parse(props.text, { breaks: true, gfm: true })
      return DOMPurify.sanitize(raw)
    })
    return { renderedHtml }
  },
}
</script>
